// 请求出口与身份仓库共用版本号，避免互相导入，并作废失效前仍在飞的身份响应。
let revision = 0;
let invalidated = false;
const listeners = new Set<() => void>();

/** 记录异步请求所属的本地会话版本。 */
export const sessionRevision = () => revision;

/** 新身份确认后允许下一轮失效处理，旧请求仍属于旧版本。 */
export function establishSession(): void {
  revision += 1;
  invalidated = false;
}

/** 同一会话只清理一次；旧会话的迟到错误不能踢掉新登录。 */
export function invalidateSession(expectedRevision = revision): boolean {
  if (expectedRevision !== revision || invalidated) return false;
  revision += 1;
  invalidated = true;
  listeners.forEach((listener) => listener());
  return true;
}

/** 身份仓库同步订阅清理，跳转前权限即已撤回。 */
export function onSessionInvalidated(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * 「这次离开是因为会话失效」的一次性记号。
 *
 * 401 要整页跳到登录页，跳转会销毁还在弹的 toast，所以把提示留给登录页：
 * 跳之前记一笔，登录页挂载时消费并弹一次。会话失效是整站级的事，用 sessionStorage
 * 而不是 location 上的参数——回跳地址已经有 `redirect` 与 `reason` 两个参数，
 * 再加一个只会让地址栏越来越长，而且刷新登录页会重复弹。
 */
const EXPIRED_NOTICE_KEY = 'muou.session.expired';

/** 跳登录页之前记一次。隐私模式禁止存储时静默放过——丢一次提示不影响回到登录页。 */
export function markSessionExpired(): void {
  try {
    sessionStorage.setItem(EXPIRED_NOTICE_KEY, '1');
  } catch {
    // 存储不可用（隐私模式 / 配额满）时不阻断跳转
  }
}

/** 登录页挂载时取一次记号：取到即清，之后刷新不再重复提示。 */
export function consumeSessionExpired(): boolean {
  try {
    const hit = sessionStorage.getItem(EXPIRED_NOTICE_KEY) === '1';
    if (hit) sessionStorage.removeItem(EXPIRED_NOTICE_KEY);
    return hit;
  } catch {
    return false;
  }
}
